export interface ManagerResidentRow {
  id: number;
  company: string;
  cluster: string;
  manager: string;
  phone: string;
  email: string;
  status?: string;
  editUrl?: string;
}

export interface ManagerResidentsNav {
  totalCount: number;
  pageSize: number;
  currentPage: number;
  pageCount: number;
}

export interface ManagerResidentsClusterOption {
  id: string;
  name: string;
}

export interface ManagerResidentsListData {
  items: ManagerResidentRow[];
  nav: ManagerResidentsNav;
  clusters: ManagerResidentsClusterOption[];
}

export interface ManagerResidentsFilter {
  clusterId?: string;
  statusId?: string;
}

export const MANAGER_RESIDENTS_PAGE_SIZE = 10;

export interface ManagerResidentStatusOption {
  id: string;
  name: string;
  code?: string;
}

export interface ManagerResidentsFilterData {
  statuses: ManagerResidentStatusOption[];
  clusters: ManagerResidentsClusterOption[];
}

export interface CreateManagerResidentPayload {
  name: string;
  description?: string;
  inn: string;
  ogrn?: string;
  website?: string;
  shortName?: string;
  legalAddress?: string;
  actualAddress?: string;
  status: string;
  phone?: string;
  email: string;
  shortDescription?: string;
  cluster: string;
  businessArea?: string;
  image?: File;
}

export interface ManagerResidentContact {
  fullName: string;
  position: string;
  phone: string;
  email: string;
}

export interface ManagerResidentDetail {
  id: number;
  status: ManagerResidentStatusOption;
  statusOptions: ManagerResidentStatusOption[];
  logoUrl: string;
  fullName: string;
  shortName: string;
  projectDescription: string;
  inn: string;
  ogrn: string;
  legalAddress: string;
  actualAddress: string;
  email: string;
  phone: string;
  website: string;
  clusterId: string;
  clusterName: string;
  contact: ManagerResidentContact;
}
